import { render, staticRenderFns } from "./PendingUserManagementRequestsModal.vue?vue&type=template&id=47fd3612&scoped=true"
import script from "./PendingUserManagementRequestsModal.vue?vue&type=script&lang=js"
export * from "./PendingUserManagementRequestsModal.vue?vue&type=script&lang=js"
import style0 from "./PendingUserManagementRequestsModal.vue?vue&type=style&index=0&id=47fd3612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd3612",
  null
  
)

export default component.exports